var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              default: "",
              name: "feed",
              label: _vm.$t(_vm.title_feed),
              icon: "fas fa-broadcast-tower"
            },
            slot: "title"
          }),
          _c("q-tab-pane", { attrs: { name: "feed" } }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [_c("activities", { attrs: { page_feed: true } })],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }